export default {"src":"https://static.spiritory.com/_next/static/media/authenticatinglogo.5a551ea7.svg","height":61,"width":68,"blurWidth":0,"blurHeight":0};